<template>
    <div>
        <h2
            class="def-header-2"
            v-if="listMessages.searchTitle"
            v-html="listMessages.searchTitle"
        ></h2>
        <div class="catalog-top pagination-scroll-js">
            <div class="catalog-top__filter">
                <div
                    @click="handlerMobileFilter"
                    class="catalog-top__filter-mobile"
                >
                    <svg>
                        <use xlink:href="#svg-filter-menu"></use>
                    </svg>
                    <h5 class="catalog-top__title">{{ filterMessages.title }}</h5>
                </div>
                <span
                    @click="handlerShowFilter"
                    class="catalog-top__close"
                >
                    <span>
                         {{ catalogSmartFilter.messages.collapse }}:
                    </span>
                </span>
                <div class="list-view">
                    <div
                        @click="changeProductListCardType(2)"
                        :class="{'list-view__active' : productListCardType === 2}"
                        class="list-view__two"
                    >
                        <div class="list-view__square"></div>
                        <div class="list-view__square"></div>
                    </div>
                    <div
                        @click="changeProductListCardType(1)"
                        class="list-view__one"
                        :class="{'list-view__active' : productListCardType === 1}"
                    >
                        <div class="list-view__square"></div>
                    </div>
                </div>
            </div>
            <!--Mobile Filter-->
            <vue-popup
                :modelValue="isOpenFilter && screenWidth < 992"
                @update:modelValue="setOpenFilter(false)"
            >
                <CatalogFilter
                    :result="catalogSmartFilter"
                    @changeFilter="handlerChangeFilter"
                    @resetFilter="changePageData"
                    @remove="handlerRemove"
                />
            </vue-popup>
            <div class="catalog-top__sort">
                <span class="catalog-top__sort-title">
                    <span>
                         {{ catalogSmartFilter.messages.sort }}:
                    </span>
                </span>
                <SelectVueSort
                    :result="catalogSort"
                    @change="changePageData"
                />
            </div>
        </div>
        <div :class="{'catalog-grid': productListCardType === 3}">
            <!--Десктоп фильтр-->
            <!--Меняем вид фильтра когда список товара открыт на всю страницу десктоп-->
            <CatalogFilter
                v-if="!isOpenFilter && screenWidth >= 992"
                :result="catalogSmartFilter"
                @changeFilter="changeFilter"
                @resetFilter="changePageData"
                class="catalog-filter"
                @remove="handlerRemove"
            />

            <ProductsList
                :result="catalogSectionList"
                :catalogListShow="productListCardType"
                :showMore="result.showMore"
                :filter="showSmallFilterDesktop"
            />
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';

import DefProgramMe from "../def/DefProgramMe/DefProgramMe";

export default {
    name: 'Catalog',
    props: {
        result: {
            type: Object,
            default: () => catalogData
        }
    },
    components: {
        DefProgramMe,
    },
    data() {
        return {
            showSmallFilterDesktop: false,
        }
    },
    computed: {
        ...mapState({
            listMessages: ({ catalog }) => catalog.data.catalogSectionList.messages,
            catalogSectionList: ({ catalog }) => catalog.data.catalogSectionList,
            filterMessages: ({ catalog }) => catalog.data.catalogSmartFilter.messages,
            productListCardType: ({ catalog }) => catalog.data.productListCardType,
            isOpenFilter: ({ catalog }) => catalog.data.isOpenFilter,
            catalogSort: ({ catalog }) => catalog.data.catalogSort,
            catalogSmartFilter: ({ catalog }) => catalog.data.catalogSmartFilter,
        })
    },
    methods: {
        ...mapMutations({
            setState: 'catalog/setState',
            changeProductListCardType: 'catalog/changeProductListCardType',
            setOpenFilter: 'catalog/setOpenFilter',
            deleteSelectedItem: 'catalog/deleteSelectedItem',
        }),
        ...mapActions({
            changePageData: 'catalog/changePageData',
            changeFilter: 'catalog/changeFilter',
        }),
        handlerShowFilter() {
            if (this.productListCardType === 3) {
                this.changeProductListCardType(4);
            } else if (this.productListCardType === 4) {
                this.changeProductListCardType(3);
            }

            this.setOpenFilter(!this.isOpenFilter);
        },
        async handlerRemove(item) {
            this.deleteSelectedItem(item);
            setTimeout(this.changeFilter, 4);
        },
        handlerMobileFilter() {
            if (this.screenWidth < 992) {
                this.setOpenFilter(true);
            }
        },
        handlerChangeFilter() {
            this.setOpenFilter(false);
            this.changeFilter();
        }
    },
    beforeMount() {
        this.setState(this.result);
    },
    mounted() {
        document.onreadystatechange = () => {
            if (document.readyState == "complete") {
                let currentUrl =window.location.href;
                $("html:not(:animated),body:not(:animated)").animate({scrollTop: 0}, 10,function () {
                    if(window.history.state) {
                        //currentUrl = window.history.state.path;
                    }
                    let elementId = localStorage[currentUrl];
                    if(elementId!=undefined&&elementId!=null&&elementId!="") {
                        let domElement = document.querySelector('#'+elementId);

                        let destination = 0;
                        // console.log(domElement.offsetTop);
                        if(domElement) {
                            if(domElement.offsetTop != undefined) {
                                destination = domElement.offsetTop-60;
                                localStorage[currentUrl] = "";
                            }
                        }
                        $("html:not(:animated),body:not(:animated)").animate({scrollTop: destination}, 20);
                    }
                });
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.catalog-top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    color: var(--text-colour-primary);
    flex-direction: column;
    @include point-md{
        flex-direction: row;
    }
    &__filter{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 500;
        color: var(--text-colour-secondary);
        width: 100%;
        margin-bottom: 16px;
        @include point-md{
            width: auto;
            margin-bottom: 0;
        }
        @include point-lg{
            justify-content: flex-start;
            color: var(--text-colour-primary);
        }
        svg{
            width: 16px;
            height: 10px;
            margin-right: 8px;
            fill: var(--border-colour-primary);
            @include point-md{
                width: 24px;
                height: 15px;
            }
        }
    }
    &__filter-mobile{
        display: flex;
        align-items: center;
        svg{
            display: block;
            @include point-lg{
                display: none;
            }
        }
    }
    &__title{
        margin-right: 8px;
        font-size: rem(14);
        letter-spacing: 0.08em;
        text-transform: uppercase;
        @include point-md{
            font-size: rem(18);
        }
    }
    &__close{
        font-size: rem(12);
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: var(--text-colour-secondary);
        display: none;
        &:hover{
            cursor: pointer;
        }
        @include point-lg{
            display: inline-block;
        }
    }
    &__sort{
        display: flex;
        flex-direction: column;
        background-color: #fff;
        width: 100%;
        text-align: left;
        padding: 10px 16px;
        @include point-md{
            padding: 0;
            flex-direction: row;
            background-color: transparent;
            width: 260px;
            text-align: center;
            align-items: center;
        }
    }
    &__sort-title{
        font-size: rem(16);
        margin-bottom: 4px;
        color: #757575;
        @include point-md{
            color: var(--text-colour-primary);
            margin-right: 8px;
            margin-bottom: 0px;
        }
    }

}
.catalog-grid{
    @include point-lg{
        display: grid;
        grid-template-columns: 25% 75%;
        grid-column-gap: 4px;
    }
}
.searchTitle {
    text-align: center;
    text-transform: uppercase;
    font-size: 20px;
    font-weight: 500;
}

.list-view{
    display: flex;
    align-items: center;
    @include point-md{
        display: none;
    }
    &__two{
        display: flex;
        margin-right: 20px;
        .list-view__square{
            width: 7px;
            &:first-child{
                margin-right: 2px;
            }
        }
    }
    &__square{
        background: #DFDFDF;
        height: 16px;
        width: 10px;
    }
    &__active{
        .list-view__square{
            background: #618EAF;
        }
    }
}
.catalog-filter{
    display: none;
    @include point-lg{
        display: block;
    }
}
</style>